import {Door} from "./door";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";

export class ExteriorDoor extends Door {
    constructor(exteriorDoorPreview) {
        super(exteriorDoorPreview);
        this.setHeightToWallHeight = true;
    }

    create(wallGroup = null, wallMeshName = null) {
        let result = super.create(wallGroup, wallMeshName);
        if (result) {
            this.cutOutGroup.name = "exteriorDoorGroup";
            recalculateBuildingParameters().then();
        }

        return result;
    }

    setControlObjectUserData(wallMeshName, sceneMatrix) {
        super.setControlObjectUserData(wallMeshName, sceneMatrix);
        this.controlObject.userData.type = "exteriorDoor";
    }
}
